export default "__VITE_ASSET__CkFcbEam__"